<div class="filter-tabs-container">
  <!-- MOBILE FILTER -->
  <div class="mobile-filter" *ngIf="isMobile">
    <button class="filter-btn" (click)="toggleDropdown()">
      <i class="pi pi-filter"></i>
      <span class="filter-label">{{ getActiveTabLabel() }}</span>
    </button>

    <div class="dropdown" #dropdown *ngIf="showDropdown">
      <button
        class="filter-tab"
        [class.active]="activeTab === tab.id"
        (click)="onTabClick(tab.id)"
        *ngFor="let tab of tabs; trackBy: trackByFn"
      >
        {{ tab.label }}
        <span *ngIf="tab.count !== undefined" class="tab-count">
          ({{ tab.count }})
        </span>
      </button>
    </div>
  </div>

  <!-- DESKTOP TABS -->
  <div class="tabs-wrapper" *ngIf="!isMobile">
    <button
      class="filter-tab"
      [class.active]="activeTab === tab.id"
      (click)="onTabClick(tab.id)"
      *ngFor="let tab of tabs; trackBy: trackByFn"
    >
      {{ tab.label }}
      <span *ngIf="tab.count !== undefined" class="tab-count">
        ({{ tab.count }})
      </span>
    </button>
  </div>
</div>
